(() => {
  const popovers = () => Array.from(document.querySelectorAll('details[data-nbg-popover][open]'));
  document.addEventListener('click', (event) => {
    popovers().forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('focusin', (event) => {
    popovers().forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('toggle', (event) => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches('[data-nbg-popover]') || !menu.open) return;
    popovers().forEach((other) => { if (other !== menu && other.name === menu.name) other.open = false; });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menus = popovers();
    const current = menus.find((menu) => menu.contains(document.activeElement));
    menus.forEach((menu) => { menu.open = false; });
    current?.querySelector('summary')?.focus();
  });
  document.addEventListener('search:open', () => popovers().forEach((menu) => { menu.open = false; }));

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;
  const revealSections = () => {
    if (motion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    if (!revealObserver) revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('nbg-reveal-pending');
        entry.target.classList.add('nbg-reveal-shown');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
    document.querySelectorAll('.template-index #MainContent > .shopify-section').forEach((section) => {
      if (section.hasAttribute('data-nbg-reveal') || section.querySelector('.nbg-shop-intro')) return;
      const box = section.getBoundingClientRect();
      section.setAttribute('data-nbg-reveal', '');
      if (box.height < 48 || box.top < window.innerHeight + 16) return;
      section.classList.add('nbg-reveal-ready', 'nbg-reveal-pending');
      revealObserver.observe(section);
    });
  };
  motion.addEventListener('change', () => {
    if (motion.matches) {
      revealObserver?.disconnect();
      document.querySelectorAll('.nbg-reveal-pending').forEach((section) => section.classList.remove('nbg-reveal-pending'));
    } else revealSections();
  });
  document.addEventListener('shopify:section:load', revealSections);
  revealSections();

  if (!customElements.get('nbg-product-search')) {
    customElements.define('nbg-product-search', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.input = this.querySelector('input[type="search"]');
        this.popup = this.querySelector('[data-nbg-search-popup]');
        this.list = this.querySelector('[role="listbox"]');
        this.status = this.querySelector('[data-nbg-search-status]');
        this.empty = this.querySelector('[data-nbg-search-empty]');
        this.catalogOptions = Array.from(this.querySelector('[data-nbg-catalog-options]')?.content.querySelectorAll('[data-nbg-catalog-choice]') || []);
        this.index = -1;
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.controller?.abort();
          this.cancelled = false;
          this.close();
          const query = this.input.value.trim();
          if (query.length < 2) { this.list.replaceChildren(); this.status.textContent = ''; return; }
          this.timer = setTimeout(() => this.load(query), 240);
        });
        this.input.addEventListener('focus', () => {
          this.cancelled = false;
          if (this.input.value.trim() === this.lastQuery) this.show();
        });
        this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) { this.cancelled = true; this.close(); } });
        this.input.addEventListener('keydown', (event) => this.onKey(event));
        this.list.addEventListener('pointerdown', (event) => {
          if (event.target.closest('a')) event.preventDefault();
        });
        this.querySelector('form').addEventListener('submit', (event) => {
          this.cancelled = true;
          this.controller?.abort();
          this.close();
          const parsed = window.NbgShopping.intent(this.input.value);
          const query = parsed.terms.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
          const region = this.catalogOptions.find((item) => {
            if (!item.hasAttribute('data-nbg-region')) return false;
            const label = item.querySelector('.nbg-search-result__title').textContent.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
            return label === query || ` ${item.dataset.keywords} `.includes(` ${query} `);
          });
          const url = region ? new URL(region.querySelector('a').href) : window.NbgShopping.searchUrl(this.querySelector('form').action, parsed);
          if (parsed.min !== '') url.searchParams.set('filter.v.price.gte', parsed.min);
          if (parsed.max !== '') url.searchParams.set('filter.v.price.lte', parsed.max);
          event.preventDefault();
          window.location.assign(url.toString());
        });
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
      close() {
        this.popup.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.index = -1;
        this.list.querySelectorAll('[role="option"]').forEach((item) => item.setAttribute('aria-selected', 'false'));
      }
      show() {
        if (this.cancelled || document.activeElement !== this.input || this.lastQuery !== this.input.value.trim()) return;
        this.popup.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }
      catalogMatches(query) {
        const words = query.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/);
        return this.catalogOptions.filter((item) => {
          const haystack = `${item.dataset.keywords} ${item.textContent}`.toLowerCase();
          return words.every((word) => haystack.includes(word));
        }).slice(0, 3).map((item) => item.cloneNode(true));
      }
      renderResults(query, items) {
        this.close();
        const seen = new Set();
        const unique = items.filter((item) => {
          const href = item.querySelector('a')?.getAttribute('href');
          if (!href || seen.has(href)) return false;
          seen.add(href);
          return true;
        });
        if (matchMedia('(max-width: 749px)').matches) {
          unique.sort((a, b) => Number(b.querySelector('a')?.getAttribute('href')?.includes('/products/')) - Number(a.querySelector('a')?.getAttribute('href')?.includes('/products/')));
        }
        if (!unique.length) {
          const recovery = this.querySelector('[data-nbg-search-recovery]')?.content.firstElementChild?.cloneNode(true);
          if (recovery) {
            const parsed = window.NbgShopping.intent(query);
            const url = new URL(recovery.querySelector('a').href);
            if (parsed.min !== '') url.searchParams.set('filter.v.price.gte', parsed.min);
            if (parsed.max !== '') url.searchParams.set('filter.v.price.lte', parsed.max);
            recovery.querySelector('a').href = url.toString(); unique.push(recovery);
          }
        }
        this.list.replaceChildren(...unique);
        this.list.querySelectorAll('[role="option"]').forEach((item, index) => { item.id = `${this.list.id}-${index}`; });
        const count = this.list.children.length;
        this.empty.hidden = count > 0;
        this.lastQuery = query;
        this.status.textContent = count ? this.dataset.count.replace('__count__', String(count)) : this.dataset.empty;
        this.show();
      }
      async load(query) {
        this.controller = new AbortController();
        const controller = this.controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        const parsed = window.NbgShopping.intent(query);
        const catalogItems = this.catalogMatches(parsed.terms);
        catalogItems.forEach((item) => {
          const link = item.querySelector('a');
          const url = new URL(link.href);
          if (parsed.min !== '') url.searchParams.set('filter.v.price.gte', parsed.min);
          if (parsed.max !== '') url.searchParams.set('filter.v.price.lte', parsed.max);
          link.href = url.toString();
        });
        if (catalogItems.length) this.renderResults(query, catalogItems);
        this.status.textContent = this.dataset.loading;
        try {
          const url = new URL(this.dataset.predictiveUrl, window.location.origin);
          url.searchParams.set('q', parsed.terms);
          url.searchParams.set('section_id', 'nbg-search-suggestions');
          url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[limit]', '10');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Search response failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = html.querySelector('[data-nbg-suggestion-items]');
          if (!items) throw new Error('Search results missing');
          if (!this.isConnected || query !== this.input.value.trim() || controller.signal.aborted) return;
          const products = Array.from(items.children).filter((item) => {
            if (!item.hasAttribute('data-nbg-price')) return true;
            const price = Number(item.dataset.nbgPrice) / 100;
            return (parsed.min === '' || price >= parsed.min) && (parsed.max === '' || price <= parsed.max);
          });
          this.renderResults(query, [...catalogItems, ...products]);
        } catch (error) {
          if (!this.isConnected || query !== this.input.value.trim() || this.cancelled) return;
          if (catalogItems.length) this.renderResults(query, catalogItems);
          else this.renderResults(query, []);
          this.status.textContent = this.dataset.fallback;
        } finally { clearTimeout(timeout); }
      }
      onKey(event) {
        if (event.key === 'Escape') {
          if (!this.popup.hidden) event.preventDefault();
          this.cancelled = true;
          this.controller?.abort();
          clearTimeout(this.timer);
          this.close();
          this.status.textContent = '';
          event.stopPropagation();
          return;
        }
        const items = Array.from(this.list.querySelectorAll('[role="option"]'));
        if (event.key === 'Enter' && this.index >= 0 && !this.popup.hidden) {
          event.preventDefault();
          window.location.assign(items[this.index].querySelector('a').href);
          return;
        }
        if (!items.length || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        this.cancelled = false;
        this.show();
        this.index = Math.max(0, Math.min(items.length - 1, this.index + (event.key === 'ArrowDown' ? 1 : -1)));
        items.forEach((item, index) => item.setAttribute('aria-selected', String(index === this.index)));
        this.input.setAttribute('aria-activedescendant', items[this.index].id);
        items[this.index].scrollIntoView({ block: 'nearest', behavior: 'auto' });
      }
    });
  }
})();

(() => {
  const cache = new Map();
  const queue = [];
  let running = 0;
  const drain = () => {
    while (running < 4 && queue.length) {
      running++;
      const job = queue.shift();
      job().finally(() => { running--; drain(); });
    }
  };
  const countFor = (link) => {
    const url = new URL(link.href, location.origin);
    url.searchParams.delete('page');
    url.searchParams.delete('sort_by');
    url.searchParams.set('filter.v.availability', '1');
    if (url.pathname.endsWith('/search')) url.searchParams.set('type', 'product');
    url.searchParams.set('section_id', 'nbg-browse-counts');
    url.searchParams.sort();
    const key = url.toString();
    if (!cache.has(key)) cache.set(key, new Promise((resolve, reject) => {
      queue.push(async () => {
        try {
          const response = await fetch(key, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error('count unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const value = html.querySelector('[data-nbg-result-count]')?.getAttribute('data-nbg-result-count');
          if (value === null || value === undefined || !/^\d+$/.test(value)) throw new Error('count unavailable');
          resolve(Number(value));
        } catch (error) { reject(error); }
      });
      drain();
    }));
    return cache.get(key);
  };
  const update = async (link) => {
    if (link.dataset.nbgCountStarted) return;
    link.dataset.nbgCountStarted = 'true';
    try {
      const requestedHref = link.href;
      const count = await countFor(link);
      if (!link.isConnected || link.href !== requestedHref) return;
      if (link.hasAttribute('data-nbg-budget') && count === 0) { link.hidden = true; return; }
      const badge = document.createElement('span');
      badge.className = 'nbg-result-count';
      badge.textContent = count.toLocaleString(document.documentElement.lang || 'en');
      badge.setAttribute('aria-label', (link.dataset.nbgCountLabel || '').replace('__count__', String(count)));
      link.append(badge);
    } catch (_) { link.removeAttribute('data-nbg-count-started'); }
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => { if (isIntersecting) { observer.unobserve(target); update(target); } });
  }, { rootMargin: '30px' });
  const enhance = () => {
    document.querySelectorAll('[data-nbg-price-context]').forEach((link) => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.set('filter.v.availability', '1');
      const minimum = Number(link.dataset.nbgPriceMin), maximum = Number(link.dataset.nbgPriceMax);
      if (minimum) url.searchParams.set('filter.v.price.gte', minimum);
      if (maximum) url.searchParams.set('filter.v.price.lte', maximum);
      const nextHref = url.toString();
      if (link.href !== nextHref) {
        observer.unobserve(link);
        link.querySelector('.nbg-result-count')?.remove();
        link.removeAttribute('data-nbg-count-started');
        link.removeAttribute('data-nbg-count-observed');
        link.hidden = false;
      }
      link.href = url.pathname + url.search;
      link.removeAttribute('aria-current');
      const current = new URL(location.href);
      if (Number(current.searchParams.get('filter.v.price.gte') || 0) === minimum && Number(current.searchParams.get('filter.v.price.lte') || 0) === maximum) link.setAttribute('aria-current', 'page');
    });
    document.querySelectorAll('[data-nbg-budget],.nbg-header-panel a').forEach((link) => {
      const url = new URL(link.href, location.origin);
      if (!url.pathname.includes('/collections/') && !url.pathname.endsWith('/search')) return;
      if (url.pathname.endsWith('/search') && !url.searchParams.get('q')) return;
      if (link.dataset.nbgCountObserved) return;
      link.dataset.nbgCountObserved = 'true';
      link.dataset.nbgCountLabel = document.querySelector('[data-nbg-count-label]')?.dataset.nbgCountLabel || '__count__';
      observer.observe(link);
    });
  };
  enhance();
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('collection:reloaded', enhance);
  window.addEventListener('popstate', enhance);
})();

if (!customElements.get('nbg-mobile-buy')) {
  customElements.define('nbg-mobile-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.form = document.getElementById(this.dataset.formId);
      this.section = document.getElementById('ProductSection-' + this.dataset.sectionId);
      this.nativeButton = this.form?.querySelector('[data-add-to-cart]');
      if (!this.form || !this.nativeButton || !this.section) return;
      this.ready = true;
      this.button = this.querySelector('[data-nbg-mobile-add]');
      this.media = matchMedia('(max-width: 749px)');
      this.formVisible = true;
      this.sync = () => {
        this.button.disabled = this.nativeButton.disabled || this.nativeButton.classList.contains('btn--loading');
        this.button.textContent = this.nativeButton.querySelector('[data-add-to-cart-text]')?.textContent.trim() || this.nativeButton.textContent.trim();
        const price = this.section.querySelector('[data-product-price]');
        if (price) this.querySelector('[data-nbg-mobile-price]').textContent = price.textContent.trim();
        this.hidden = !this.media.matches || this.formVisible || this.nativeButton.getBoundingClientRect().top >= 0;
        document.body.classList.toggle('nbg-mobile-buy-active', !this.hidden);
      };
      this.observer = new IntersectionObserver((entries) => { this.formVisible = entries[0].isIntersecting; this.sync(); });
      this.observer.observe(this.nativeButton);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.nativeButton, { attributes: true, childList: true, subtree: true });
      const price = this.section.querySelector('[data-product-price]');
      if (price) this.mutations.observe(price, { childList: true, subtree: true });
      this.onVariant = () => requestAnimationFrame(this.sync);
      document.addEventListener('variant:change', this.onVariant);
      this.media.addEventListener('change', this.sync);
      this.button.addEventListener('click', () => {
        if (this.nativeButton.disabled) return;
        this.nativeButton.click();
        this.sync();
      });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutations?.disconnect();
      document.removeEventListener('variant:change', this.onVariant);
      this.media?.removeEventListener('change', this.sync);
      document.body.classList.remove('nbg-mobile-buy-active');
    }
  });
}

if (!customElements.get('nbg-search-refinements')) {
  customElements.define('nbg-search-refinements', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.querySelector('.nbg-search-refinements');
      if (!this.details) return;
      this.desktop = matchMedia('(min-width: 750px)');
      this.syncLayout = () => {
        this.details.open = this.desktop.matches;
        this.details.toggleAttribute('data-desktop-expanded', this.desktop.matches);
      };
      this.desktop.addEventListener('change', this.syncLayout);
      this.syncLayout();
    }
    disconnectedCallback() { this.desktop?.removeEventListener('change', this.syncLayout); }
  });
}
